import { fullMotion } from './experience';
import { sound } from './sound';

/** A short particle burst for milestones only (released, completed, handed over). Skipped unless motion is "full". */
export function celebrate(origin?: { x: number; y: number }) {
  sound.milestone();
  if (!fullMotion()) return;
  const canvas = document.createElement('canvas');
  const dpr = window.devicePixelRatio || 1;
  Object.assign(canvas.style, { position: 'fixed', inset: '0', width: '100vw', height: '100vh', pointerEvents: 'none', zIndex: '9999' });
  canvas.width = innerWidth * dpr;
  canvas.height = innerHeight * dpr;
  document.body.appendChild(canvas);
  const c = canvas.getContext('2d')!;
  c.scale(dpr, dpr);
  const colours = ['#22d3ee', '#a78bfa', '#34d399', '#fbbf24', '#f472b6', '#60a5fa'];
  const ox = origin?.x ?? innerWidth / 2;
  const oy = origin?.y ?? innerHeight / 3;
  const parts = Array.from({ length: 90 }, () => {
    const a = Math.random() * Math.PI * 2;
    const v = 4 + Math.random() * 7;
    return { x: ox, y: oy, vx: Math.cos(a) * v, vy: Math.sin(a) * v - 4, r: 2 + Math.random() * 3.5, c: colours[(Math.random() * colours.length) | 0]!, spin: Math.random() * 6, life: 1 };
  });
  let raf = 0;
  const step = () => {
    c.clearRect(0, 0, innerWidth, innerHeight);
    let alive = 0;
    for (const p of parts) {
      p.vy += 0.22;
      p.vx *= 0.985;
      p.x += p.vx;
      p.y += p.vy;
      p.life -= 0.011;
      p.spin += 0.2;
      if (p.life <= 0) continue;
      alive++;
      c.globalAlpha = Math.max(p.life, 0);
      c.fillStyle = p.c;
      c.save();
      c.translate(p.x, p.y);
      c.rotate(p.spin);
      c.fillRect(-p.r, -p.r / 2, p.r * 2, p.r);
      c.restore();
    }
    if (alive) raf = requestAnimationFrame(step);
    else canvas.remove();
  };
  raf = requestAnimationFrame(step);
  setTimeout(() => { cancelAnimationFrame(raf); canvas.remove(); }, 3000);
}

/**
 * A short "done" stamp in the middle of the screen (approved, posted): a tick drawn in a ring, then gone. Never in
 * the way (no clicks caught) and skipped unless motion is "full"; the toast still says what happened.
 */
export function stamp(label: string) {
  sound.approve();
  if (!fullMotion()) return;
  const el = document.createElement('div');
  el.className = 'fx-stamp';
  el.setAttribute('aria-hidden', 'true');
  el.innerHTML = `<div class="fx-stamp-ring"><svg viewBox="0 0 52 52"><circle cx="26" cy="26" r="24"/><path d="M15 27l7 7 15-16"/></svg></div><p>${label.replace(/[<>&]/g, '')}</p>`;
  document.body.appendChild(el);
  setTimeout(() => el.remove(), 1200);
}
